import { useContext, type FC } from 'react';
import type { VolatilitySmileProps } from './types';
import VolatilitySmileContent from './volatility-smile-content';
import { Widget } from '../../widget';
import TokenSelector from '../../token-selector';
import { VolSmileContext } from '../../../../providers/widgets';
import Source from '../../source';
import WidgetButtons from '../../widget-buttons';
import { CurrencyTypeEnum, VolSurfaceToken } from '../../../../model/currency_type.enum';

const VolatilitySmileWidget: FC<VolatilitySmileProps> = (props) => {
  const { widget, actions } = props;
  const { token, setToken, hasDefaultToken } = useContext(VolSmileContext);
  const handleSetToken = (value: VolSurfaceToken) => setToken(value as CurrencyTypeEnum);

  return (
    <Widget cardKey={widget.key}>
      <Widget.Header>
        <Widget.Title title={widget.title} />
        <Widget.HeaderPanel>
          {<TokenSelector token={token} setToken={handleSetToken} isFixedToken={hasDefaultToken} />}
        </Widget.HeaderPanel>
        <Widget.Buttons>
          <WidgetButtons widget={widget} actions={actions} permissions={props.permissions} />
        </Widget.Buttons>
      </Widget.Header>
      <Widget.Content>
        <VolatilitySmileContent providerKey={props.providerKey} />
      </Widget.Content>
      <Widget.Footer>
        <Source source="Deribit" url="https://www.deribit.com" />
      </Widget.Footer>
    </Widget>
  );
};

export default VolatilitySmileWidget;
